import React, { useCallback, useEffect, useState } from "react";
import { useGetAllServiceTypesMutation } from "../../api/api";
import GenericDropdown from "../../components/GenericDropDown";
import useDebounce from "../../lib/utils";

interface ServiceTypeDropdownProps {
  selectedServiceType: string;
  onChange: (value: string) => void;
  className?: string;
  dropdownMenuContentWidth?: string;
  placeholder?: string;
  isDisabled?: boolean;
}

interface Service {
  name: string;
  serviceTypeId: number;
}

const ServiceTypeDropdown: React.FC<ServiceTypeDropdownProps> = ({
  selectedServiceType,
  onChange,
  className,
  dropdownMenuContentWidth,
  placeholder,
  isDisabled,
}) => {
  const [serviceValue, setServiceValue] = useState<Service>({
    name: "",
    serviceTypeId: 0,
  });
  const [isServiceTypesLoading, setIsServiceTypesLoading] = useState(false);
  const [serviceTypesOptions, setServiceTypesOptions] = useState<any[]>([]);
  const debouncedServiceSearchQuery = useDebounce(serviceValue.name, 200);

  const [getAllServiceTypes] = useGetAllServiceTypesMutation();

  const fetchAllServices = useCallback(async () => {
    setIsServiceTypesLoading(true);
    try {
      const response: any = await getAllServiceTypes({
        getAllServiceTypesRequestDto: {
          searchQuery:
            debouncedServiceSearchQuery !== ""
              ? debouncedServiceSearchQuery
              : undefined,
          pageNumber: 1,
          pageSize: 100,
          getTotalCount: true,
          sortingColumn: "name",
          sortingOrder: "asc",
          //  isDistanceRangApplicable: true,
        },
      }).unwrap();

      const serviceTypeOptions = response.data?.serviceTypes?.map(
        (type: any) => ({
          value: type.id.toString(),
          label: type.name,
        })
      );
      setServiceTypesOptions(serviceTypeOptions || []);
    } catch (err) {
      console.error("Failed to fetch service types:", err);
    } finally {
      setIsServiceTypesLoading(false);
    }
  }, [debouncedServiceSearchQuery, getAllServiceTypes]);

  useEffect(() => {
    fetchAllServices();
  }, [fetchAllServices]);

  return (
    <>
      <GenericDropdown
        labelValue={
          serviceTypesOptions.find(
            (option) =>
              option.value ===
              (selectedServiceType === "-1" ? "0" : selectedServiceType)
          )?.label || ""
        }
        options={serviceTypesOptions}
        isDisabled={isDisabled}
        onChange={(value) => onChange(value === "-1" ? "0" : value)}
        placeholder={placeholder || "Select Service Type"}
        error={false}
        className={
          className || "w-full bg-white justify-between h-9 items-center"
        }
        dropdownMenuContentWidth={dropdownMenuContentWidth}
      />
    </>
  );
};

export default ServiceTypeDropdown;
